import { formatMoney } from 'accounting'

import { generateRedirectUrl } from '@domain-group/javascript-utils'

import { DashboardModuleListItem } from '@domain-group/suit-theme'

import { generateUrls } from '@hooks/useOrderBundle'

import { OrderBundleModel } from '@models/orderBundle'

const OrderBundleListItem = (props: {orderBundleListItem: OrderBundleModel}) => {
  const { orderBundleListItem } = props

  const { price, title } = orderBundleListItem || {}

  const url = generateUrls(orderBundleListItem)
  const { editOrderBundleUrl } = url

  return (
    <DashboardModuleListItem
      title={title}
    >
      {/*
       // @ts-expect-error TS2339 */}
      <DashboardModuleListItem.TertiaryText>
        {formatMoney(price)}
        {/*
       // @ts-expect-error TS2339 */}
      </DashboardModuleListItem.TertiaryText>

      {/*
       // @ts-expect-error TS2339 */}
      <DashboardModuleListItem.Actions>
        {/*
         // @ts-expect-error TS2339 */}
        <DashboardModuleListItem.Icon href={`${editOrderBundleUrl}?redirect=${generateRedirectUrl()}`} type="link" />
        {/*
       // @ts-expect-error TS2339 */}
      </DashboardModuleListItem.Actions>
    </DashboardModuleListItem>
  )
}

export default OrderBundleListItem
